module.exports = __webpack_public_path__ + "img/the-kings-curse.55f7b6f5.png";